import React, { useState } from 'react';
import moment from 'moment';

const tableConfig = (props) => (
	{
		columns: [
			{
				title: 'Business Name', field: 'business_name', filterAndSearch: true, width: "150px",
				// render: rowData => <UserAvatar name={rowData.name} image={rowData.dpUrl}/>
			},
			{
				title: 'Orders', field: 'payment_details.total_orders', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>{(rowData.payment_details && rowData.payment_details.total_orders) || 0}</span>}</div >
			},
			{
				title: 'Net Amout', field: 'payment_details.net_amount', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.net_amount ? rowData.payment_details.net_amount.toFixed(2) : 0)}</span>}</div >
			},
			{
				title: 'Tax', field: 'payment_details.tax', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.tax ? rowData.payment_details.tax.toFixed(2) : 0)}</span>}</div >
			},
			// {
			// 	title: 'Shipping Charges', field: 'totalShippingCharges', filterAndSearch: false, width: "80px",
			// 	render: rowData => <div>{(rowData.currency === "&#8377;") ? <span>&#8377;{rowData.totalShippingCharges}</span> : <span>&#36;{rowData.totalShippingCharges}</span>}</div>
			// },
			{
				title: 'Delivery Charges', field: 'payment_details.delivery_charges', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.delivery_charges ? rowData.payment_details.delivery_charges.toFixed(2) : 0)}</span>}</div >
			},
			{
				title: 'Convience Fees', field: 'payment_details.convience_charges', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.convience_charges ? rowData.payment_details.convience_charges.toFixed(2) : 0)}</span>}</div >
			},
			{
				title: 'Incentive', field: 'payment_details.incentive_amount', filterAndSearch: false, width: "80px",
				render: rowData => <div><b>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.incentive_amount ? rowData.payment_details.incentive_amount.toFixed(2) : 0)}</span>}</b></div >
			},
			{
				title: 'Payable Amount', field: 'payment_details.payable_amount', filterAndSearch: false, width: "80px",
				render: rowData => <div><b>{<span>&#8377;{(rowData.payment_details && rowData.payment_details.payable_amount ? rowData.payment_details.payable_amount.toFixed(2) : 0)}</span>}</b></div >
			},
			{
				title: 'Settlement Amount', field: 'payment_details.settlement_amount', filterAndSearch: false, width: "90px",
				render: rowData => <div>
					<b>
						<span>&#8377;
							{
								rowData.isAnyOrderSelected && rowData.settlementAmount
									? rowData.settlementAmount.toFixed(2)
									: "0"
							}
						</span>
					</b>
				</div>
			},
			{
				title: 'Packaging Charges', field: 'payment_details.packing_charges', filterAndSearch: false, width: "90px",
				render: rowData => <div>
					<b>
						<span>&#8377;
							{
								rowData.isAnyOrderSelected && rowData.payment_details.packing_charges
									? rowData.payment_details.packing_charges.toFixed(2)
									: "0"
							}
						</span>
					</b>
				</div>
			},
		],
	}
)

export const settlementTransactionTableConfig = (props) => (
	{
		columns: [
			{
				title: 'Settlement Date', field: 'settlement_date', filterAndSearch: false,
				render: rowData => <div>{<span>{rowData.settlement_date ? moment.utc(rowData.settlement_date).local().format("DD-MM-YYYY hh:mm") : "-"}</span>}</div >
			},
			{
				title: 'Business Name', field: 'food_seller.business_name', filterAndSearch: true, width: "150px",
				render: rowData => <div>{<span>{(rowData.food_seller && rowData.food_seller.business_name) ? rowData.food_seller.business_name : "-"}</span>}</div >
			},
			{
				title: 'Business Owner Number', field: 'food_seller.user.mobile_no', filterAndSearch: true, width: "150px",
				render: rowData => <div>{<span>{(rowData.food_seller && rowData.food_seller.user && rowData.food_seller.user.mobile_no) ? `${rowData.food_seller.user.code} ${rowData.food_seller.user.mobile_no}` : "-"}</span>}</div >
			},
			{
				title: 'Total Orders', field: 'total_settled_orders', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>{(rowData.total_settled_orders) || 0}</span>}</div >
			},
			{
				title: 'Payable Amount', field: 'payable_amount', filterAndSearch: false, width: "80px",
				render: rowData => <div><b>{<span>&#8377;{(rowData.payable_amount ? rowData.payable_amount.toFixed(2) : 0)}</span>}</b></div >
			},
			{
				title: 'Settlement Amount', field: 'settlement_amount', filterAndSearch: false, width: "90px",
				render: rowData => <div><b><span>&#8377;{rowData.settlement_amount ? rowData.settlement_amount.toFixed(2) : "0"}</span></b></div>
			},
			{
				title: 'Transaction Id', field: 'transaction_id', filterAndSearch: false, width: "80px",
				render: rowData => <div>{<span>{(rowData.transaction_id || "-")}</span>}</div>
			},
			{
				title: 'Note', field: 'settlement_description', filterAndSearch: false,
				render: rowData => <div>{(rowData.settlement_description || "-")}</div >
			},
		],
	}
)

export default tableConfig;
